import React from "react";
import { Link } from "react-router-dom";
import Chart from "react-google-charts";

const TYPE_COLORS = {
  CERAMIC: "#c82534",
  DIESEL: "#2c6fbb",
  "AFTER MKT": "#00965a",
  "DOMESTIC WIRE": "#e8a317",
  "FOREIGN WIRE": "#6b4c9a",
};

export function NoAssayNoTestsVisual({ summary }) {
  const oems = summary?.noTestsYetOems || [];
  const byType = summary?.noTestsYetByType || [];

  if (!oems.length) {
    return (
      <div className="converter-testing-glance-panel converter-testing-no-assay-no-tests-panel">
        <div className="converter-testing-glance-title">No tests yet</div>
        <div className="c-gray fs-14">All no-assay converters have at least one test record.</div>
      </div>
    );
  }

  const chartData = [
    ["Type", "No tests yet"],
    ...byType.map((row) => [row.type, row.count ?? 0]),
  ];

  return (
    <div className="converter-testing-glance-panel converter-testing-no-assay-no-tests-panel">
      <div className="converter-testing-glance-header">
        <div>
          <div className="converter-testing-glance-title">No tests yet — OEMs at a glance</div>
          <div className="converter-testing-glance-subtitle c-gray fs-13">
            {oems.length.toLocaleString()} converters missing catalog assay and lab test data
          </div>
        </div>
        <div className="converter-testing-glance-badge converter-testing-glance-badge-amber">
          {oems.length.toLocaleString()}
        </div>
      </div>

      <div className="converter-testing-no-tests-charts">
        {byType.length > 0 && (
          <div className="converter-testing-chart-card">
            <div className="converter-testing-chart-title">No tests yet by type</div>
            <Chart
              chartType="BarChart"
              width="100%"
              height="220px"
              data={chartData}
              options={{
                legend: { position: "none" },
                chartArea: { width: "70%", height: "72%" },
                hAxis: { textStyle: { fontSize: 11 }, minValue: 0 },
                vAxis: { textStyle: { fontSize: 11 } },
                colors: ["#e8a317"],
              }}
              loader={<div className="c-gray fs-13">Loading chart...</div>}
            />
          </div>
        )}

        <div className="converter-testing-no-tests-legend">
          {byType.map((row) => (
            <div key={row.type} className="converter-testing-type-legend-item">
              <span
                className="converter-testing-type-dot"
                style={{ background: TYPE_COLORS[row.type] || "#999" }}
              />
              <span className="fs-12 fw-bolder">{row.type}</span>
              <span className="fs-12 c-gray">({row.count})</span>
            </div>
          ))}
        </div>
      </div>

      <div className="converter-testing-oem-chip-grid">
        {oems.map((item) => {
          const typeColor = TYPE_COLORS[item.type] || "#999";
          return (
            <Link
              key={item.productId}
              to={`/converter/${item.productId}`}
              className="converter-testing-oem-chip"
              style={{ borderLeftColor: typeColor }}
              title={[item.type, item.description || null].filter(Boolean).join(" · ")}
            >
              <span className="converter-testing-oem-chip-text">{item.oem || item.productId}</span>
              <span className="converter-testing-oem-chip-type">{item.type}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
